<template>
  <div>
    <div v-show="isForeign">
      <div id="embed-target"></div>
    </div>
    <div class="pay-way container" v-show="!isForeign">
      <div class="pay-number">
        <span>应付 </span>
        <span>￥{{ totalAmount }}</span>
      </div>
      <div class="pay-way-title">
        <span>支付方式 Mode of payment</span>
      </div>

      <div class="pay-way-select">
        <div class="pay-way-select-item fl-align-center">
          <el-radio v-model="payWay" label="0">
            {{ " " }}
          </el-radio>
          <img class="pay-way-select-item-img" src="@/assets/img/wechat-icon.png" alt=""/>
          <span class="primary-text mar-l-28">微信支付 Wechat payment</span>
        </div>
<!--        <div class="pay-way-select-item fl-align-center">-->
<!--          <el-radio v-model="payWay" label="3">-->
<!--            {{ " " }}-->
<!--          </el-radio>-->
<!--          <img class="pay-way-select-item-img" src="@/assets/img/foreign-icon.png" alt=""/>-->
<!--          <span class="primary-text mar-l-28">外币支付 Foreign currency payment</span>-->
<!--        </div>-->
        <!--      <div class="pay-way-select-item fl-align-center">-->
        <!--        <el-radio v-model="payWay" label="1">{{ " " }} </el-radio>-->
        <!--        <img class="pay-way-select-item-img" src="@/assets/img/bag-icon.png" alt="" />-->
        <!--        <span class="primary-text mar-l-28">钱包支付</span>-->
        <!--        <div class="wallet-desc">-->
        <!--          <span>余额：￥{{ moneybagRest }} </span>-->
        <!--          <span>奖励金余额：￥{{ bonusBalance }}</span>-->
        <!--          <span>本次可用：￥{{ bonusCanUsed }}</span>-->
        <!--        </div>-->
        <!--      </div>-->
      </div>
      <div class="pay-btn-content">
        <el-button type="primary" size="default" :loading="payLoading"
                   @click="handlePay">立即支付 Pay now
        </el-button>
      </div>
      <SharePayDialog
          title="微信扫码完成支付 Scan the QR code to pay"
          v-if="sharePayVisible"
          :visible.sync="sharePayVisible"
          :payImg="payImg"
          @on-success="getOrderStatus"
      />
    </div>
  </div>
</template>

<script>
import SharePayDialog from "./components/SharePayDialog.vue";
import {hotelOrderCreditCallback} from "@/api/api";

export default {
  name: "PayWay",
  components: {SharePayDialog},
  data() {
    return {
      payLoading: false,
      isForeign: false,//是否是外币支付
      payWay: "0",
      totalAmount: "0.00", //钱
      bonusCanUsed: "", // 本次可抵扣余额
      bonusBalance: "", // 奖励金余额
      moneybagRest: "", //余额
      payBtnDisabled: false,
      payImg: "", //小程序订单分享页面
      sharePayVisible: false,
    };
  },
  computed: {
    orderNo() {
      return this.$route.query.orderNo;
    },
    orderType() {
      //s 商品订单 h订房订单
      return this.$route.query.orderType;
    },
  },
  async mounted() {
    const _this = this
    await this.getUserPayDetail();
    window.checkoutOrderBack = function (type, message) {
      if (type == 'error') {
        _this.isForeign = false
        _this.$message.error(message)
      } else if (type == 'complete') {
        _this.foreignPayComplete()
      }
    }
  },
  methods: {
    //外币支付完成，通知服务器更新订单信息
    foreignPayComplete: async function () {
      const loading = this.$loading({
        lock: true,
        text: '同步订单信息',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.1)'
      })
      const orderNo = this.orderNo;
      const orderType = this.orderType;
      try {
        if (orderType == 's') {
          const {data} = await this.$api.orderCreditCallback({orderNo})
          const apiResult = data?.apiResult
          if (apiResult != "SUCCESS") {
            this.$message.warning('订单数据同步失败')
          }
          await this.$router.push(`/e-shop/pay-result`);
        } else if (orderType == 'h') {
          const {data} = await this.$api.hotelOrderCreditCallback({orderNo})
          const apiResult = data?.apiResult
          if (apiResult != "SUCCESS") {
            this.$message.warning('订单数据同步失败')
          }
          await this.$router.push(`/home/pay-result?orderNo=${this.orderNo}`);
        }
        loading.close()
      } catch (e) {
        if (orderType == 's') {
          await this.$router.push(`/e-shop/pay-result`);
        } else if (orderType == 'h') {
          await this.$router.push(`/home/pay-result?orderNo=${this.orderNo}`);
        }
        loading.close()
      }
    },
    async getOrderStatus() {
      let orderData;
      const params = {
        orderNo: this.orderNo,
      };
      const orderType = this.orderType
      if (orderType == 's') {
        orderData= await this.getOrderCommonDetail()
      } else if (orderType == 'h') {
        orderData = await this.$api.getHotelOrderDetail(params);
      }
      if (orderData && orderData.orderVO && orderData.orderVO.payTime) {
        if (orderType == 's') {
          await this.$router.push(`/e-shop/pay-result`);
        } else if (orderType == 'h') {
          await this.$router.push(`/home/pay-result?orderNo=${this.orderNo}`);
        }
        this.sharePayVisible = false;
      } else {
        this.$message.warning("支付未完成");
      }
    },
    async getOrderCommonDetail() {
      const params = {
        orderNo: this.orderNo,
      };
      try {
        let {data} = await this.$api.getOrderCommonDetail(params);
        return data;
      } catch (error) {
        console.log(error);
      }
    },
    async getUserPayDetail() {
      try {
        let {data} = await this.$api.getUserPayDetail({orderNo: this.orderNo});
        this.totalAmount = data.payAmount ?? "0.00";
        this.bonusCanUsed = data.bonusCanUsed ?? "0.00";
        this.bonusBalance = data.bonusBalance ?? "0.00";
        this.moneybagRest = data.moneybagRest ?? "0.00";
        this.payBtnDisabled = data.moneybagRest - 0 > data.payAmount - 0 ? false : true;
      } catch (error) {
        console.log(error);
      }
    },
    //外币支付
    foreignPayment: async function () {
      this.payLoading = true
      let {data} = await this.$api.getSession({
        "amount": this.totalAmount,
        "orderNo": this.orderNo
      }).catch(() => {
        this.payLoading = false
      })
      if (!data) return;
      this.payLoading = false
      this.isForeign = true
      Checkout.configure({
        session: {
          id: data.id
        },
        order: {
          description: 'BEIJING INTERNATIONAL HOTEL',
          id: this.totalAmount
        },
        interaction: {
          merchant: {
            name: 'BEIJING INTERNATIONAL HOTEL',
            address: {
              line1: 'The Beijing International Hotel Convention Center',
              line2: 'Adjacent to the main hotel building'
            }
          }
        }
      });

      Checkout.showEmbeddedPage('#embed-target',
          () => {
            console.log('showLightboxFunc')
          }
      );
    },
    //支付 0微信支付 3外币支付
    async handlePay() {
      if (this.payWay == "3") {
        await this.foreignPayment();
      } else {
        await this.getQrCode();
      }
    },
    async getQrCode() {
      let {data} = await this.$api.createLink({
        content: JSON.stringify({orderNo: this.orderNo}),
      });
      const params = {
        page: `implant/orders/detail/index`,
        scene: data?.shortLink,
      };
      try {
        let {data} = await this.$api.getQrCode(params);
        this.payImg = data;
        this.sharePayVisible = true;
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.pay-way {
  padding-top: 62px;

  .pay-number {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
  }

  .pay-way-title {
    font-size: 14px;
    color: #333333;
    margin-top: 60px;
    margin-bottom: 57px;
  }

  .pay-way-select-item {
    height: 80px;
    border-bottom: 1px solid #f0f0f0;

    .pay-way-select-item-img {
      width: 30px;
      height: 30px;
    }

    .wallet-desc {
      span {
        margin-left: 100px;
        font-size: 14px;
        color: #999999;
      }
    }
  }

  .mar-l-28 {
    margin-left: 28px;
  }

  .pay-btn-content {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
  }
}
</style>
